export var SET_TYPE_HEADER = "setTypeHeader";